export default "__VITE_ASSET__CVEmTr8G__"